import styles from "./OutOfStockExperienceInfo.module.scss";
import { StoreStock } from "../../../__shared__/StoreStock/StoreStock";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const outOfStockMessage: string = "Currently out of stock online";
const inStoreOnlyMessage: string = "Available in-store only";

export type Props = {
  isFutureRelease: boolean;
  isInStoreOnly: boolean;
  isPreOrderable: boolean;
  isVariantSelected: boolean;
  stockApiBaseUrl: string;
  stockApiKey: string;
  storeStockApiKey: string;
  storeStockDisplayCode: string;
  storeStockModalApiUrl: string;
  storeStockScriptUrl: string;
  storeStockSkuId: string;
  storeStockTitle: string;
};

export const OutOfStockExperienceInfo = ({
  isFutureRelease,
  isInStoreOnly,
  isPreOrderable,
  isVariantSelected,
  stockApiBaseUrl,
  stockApiKey,
  storeStockApiKey,
  storeStockDisplayCode,
  storeStockModalApiUrl,
  storeStockScriptUrl,
  storeStockSkuId,
  storeStockTitle,
}: Props) => {
  return (
    <div
      data-testid="product:basket:out-of-stock-experience"
      className={cx(styles.outOfStockExperienceInfoWrapper, {
        inStoreOnly: isInStoreOnly,
      })}
    >
      <div className={styles.outOfStockExperienceInfo}>
        <h2>{isInStoreOnly ? inStoreOnlyMessage : outOfStockMessage}</h2>
      </div>
      <StoreStock
        title={storeStockTitle}
        displayCode={storeStockDisplayCode}
        skuId={storeStockSkuId}
        isPreOrderable={isPreOrderable}
        isFutureRelease={isFutureRelease}
        usePrimaryButton={true}
        storeStockScriptUrl={storeStockScriptUrl}
        stockApiKey={stockApiKey}
        stockApiBaseUrl={stockApiBaseUrl}
        storeStockApiKey={storeStockApiKey}
        storeStockModalApiUrl={storeStockModalApiUrl}
        hideIfStoreStockUnavailable={false}
        isVariantSelected={isVariantSelected}
      />
      <div
        id="store-stock-error-wrapper"
        data-testid="product:tools:store-stock:error"
      />
    </div>
  );
};
